/*
This js code  targets product frame variants, to dynamically update the displayed selected option. It makes sure only the right variant images are shown

Here's a step-by-step breakdown of what each part of the code does:

Event Listener for 'DOMContentLoaded': The script starts by setting up an event listener that waits for the browser to finish loading the entire HTML document (DOMContentLoaded). 
This ensures that all elements are available for manipulation before the script runs.

Selection of Variant Input Elements: The code uses document.querySelectorAll to find all input elements of type radio and buttons within elements that have a class of .product-form__swatch. 
These elements are assumed to be the controls that allow users to select product variants like size or color.

updateVariantDisplay Function: This function is defined to handle the change in variant selection.

Event Trigger Information: It first determines whether the event was triggered by a button or an input element by checking the tag name of the event's target (e.target.tagName).
Retrieve Selected Value: For buttons, it retrieves the data-value attribute to get the variant value; for input elements (like radio buttons), it simply uses the value property.
Identify Option Name: It gets the name of the option (e.g., size, color) that was changed using e.target.name.
Display Update: The function locates a corresponding element (assumed to display the selected variant) by building an ID string ('selected' + optionName) and updates its text content to reflect the newly selected value.
Adding Event Listeners to Each Variant Input: The code iterates over each variant input element collected earlier, attaching the updateVariantDisplay function as an event handler for the change event. 
Additionally, if the element is a button, it also attaches the handler to the click event to handle button clicks.

Initialization Debugging Statement: Finally, after setting up the event listeners, a console log statement indicates that the event listeners are properly configured.

This script effectively makes the product variant selection more interactive and user-friendly, as users receive immediate visual feedback on their selections without needing to rely on form submissions or page reloads. 
This can enhance user experience and potentially reduce confusion and errors in selecting product variants.
*/

document.addEventListener('DOMContentLoaded', () => {
    const updateVariantDisplay = (e) => {
        const { tagName, value, name, dataset } = e.target;
        const selectedValue = tagName === 'BUTTON' ? dataset.value : value;
        const variantDisplay = document.getElementById(`selected${name}`);
        variantDisplay && (variantDisplay.textContent = selectedValue);

        if (name === 'Frame' && selectedValue === 'Glide') {
            const blackMetalFinishInput = document.querySelector('input[name="Frame Finish"][value="Black (Metal)"]');
            if (blackMetalFinishInput) {
                blackMetalFinishInput.checked = true;
                const frameFinishDisplay = document.getElementById('selectedFrame Finish');
                frameFinishDisplay && (frameFinishDisplay.textContent = 'Black (Metal)');
            }
        }
    };

    document.querySelectorAll('.product-form__swatch input[type="radio"], .product-form__swatch button')
        .forEach(input => {
            input.addEventListener('change', updateVariantDisplay);
            input.tagName === 'BUTTON' && input.addEventListener('click', updateVariantDisplay);
        });

    document.querySelectorAll('.product-form__swatch input[type="radio"]').forEach(input => {
        const label = document.querySelector(`label[for="${input.id}"]`);
        const backgroundImageUrl = {
            'Beige (Metal)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/creme.jpg',
            'Peach (Metal)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/peach.jpg',
            'Mint (Metal)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/mint.jpg',
            'Brown (Metal)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/brown.jpg',
            'Gold (Metal)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/brushed-gold1.jpg?v=1718709690',
          'Rose (Metal)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/rose1.jpg?v=1718709690',
          'White (Metal)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/white.jpg?v=1713948203',
          'Steel (Metal)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/steel1.jpg?v=1718709631',
          'Bleach (Oak)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/Bleach__Oak.jpg?v=1748287833',
          'Walnut (Oak)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/Walnut_Oak.jpg?v=1748336012',
          'Natural (Oak)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/Natural_Oak.jpg?v=1748336012',
          'Black (Oak)': 'https://cdn.shopify.com/s/files/1/0845/5307/2989/files/Black_Oak.jpg?v=1748336014'
        }[input.value] || input.dataset.imageUrl;
        if (backgroundImageUrl) {
            label.style.backgroundImage = `url(${backgroundImageUrl})`;
            label.style.backgroundSize = 'cover';
        }
    });

    console.log('Event listeners set up.');
});


